/**
 * @title checkout_helper.js: Feature level module
 * @description Utility module associated with checkout
 */
define(['address'], function(address) {
  var CAddressDisplay = {
    createAddressDisplay: function(obj, type) {
      var data = CAddressDisplay.buildAddressJson(obj); 
      if(obj.phone){
    	  obj.phone = COSTCO.util.formatPhone(obj.phone);
      }
      
      return COSTCO.util.tmpl('tmpl_address_display', obj);
    },
    createAddressVerificationDisplay: function(obj, template) {
      var data = CAddressDisplay.buildAddressJson(obj);
      if(template == null || template == '' || typeof template === 'undefined') {
    	  //set default template if template is not passed in the argument
    	  template = 'tmpl_address_display_verification';
      } 
      return COSTCO.util.tmpl(template, obj);
    },
    buildAddressJson: function(obj) {
      var data;
      if (typeof(obj) === 'number') {
        var addressJson = address.getAddressJson(obj)[0];
        if (addressJson.length == 0) return '';
        data = addressJson[0];
      } else {
        data = obj;
      }
      return data;
    }
  }
  if (typeof window.COSTCO === "undefined") {
    window.COSTCO = new Object();
  }
  window.COSTCO.CAddressDisplay = CAddressDisplay;
  return CAddressDisplay;
});



// WEBPACK FOOTER //
// ./js/address/addressDisplay.js